import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasValidSession } from "../../utils/authSession";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { pathname } = useLocation();
  const loginPath = pathname.startsWith("/dashboard-insured") || pathname.startsWith("/dashboard-workshop")
    ? "/login/insured"
    : "/";

  return hasValidSession(allowedRoles) ? <Outlet /> : <Navigate to={loginPath} replace />;
};

export default ProtectedRoute;
